import * as React from 'react';
import classNames from 'classnames';

export interface ModalBodyProps {
  children?: React.ReactNode;
  className?: string;
  complex?: boolean;
}

const ModalBody: React.FC<ModalBodyProps> = (props: ModalBodyProps) => {
  const { complex, children, className } = props;

  const modalBodyClass = classNames(className, 'ui-modal-body', {
    'ui-modal-body--complex': complex,
  });

  return <div className={modalBodyClass}>{children}</div>;
};

export default ModalBody;
